import hash from "../hash";
import * as $$$Echangeur from "../Echangeur";

import { createApp } from "vue";
import htmlcart from "./orderManagerCart.html";
import Store from "../Store";
import { traduit, toPrix } from "./composant/b2bLangue";

const SELECTOR = "#offcanvasCart";
const element = document.querySelector(SELECTOR);
const imagPardefaut = "0000000/0000000_0000_1_*.png";

const jscart = {
  url: function (echangeur) {},
  onLoad: function (echangeur) {
    let THIS = this;

    let objectConteneur = this.objectConteneur;


    
    let CTX = Store.get("CTX"); 
    console.log("CTX", CTX)

    let isUserEdi = false;
    if(CTX && CTX.session && CTX.session.isEdi) isUserEdi=true 

    const app = createApp({
      data: function () {
        return {
          // hash: echangeur.hash,
          currentOrder: {}, // echangeur.currentOrder,
          listOrders: [],
          idSelected: "", // echangeur.currentOrder._id,
          docOrder: { rows: [] },
          isUserEdi:isUserEdi
        };
      },
      methods: {
        toPrix(value, devise) {
          return toPrix(value, devise);
        },
        viewOrder: function () {
          objectConteneur.hide();
          hash.lance("orderValidate", {_id: this.idSelected,formLinelist: true,});
        },
        urlImg(img) {
          return ("download/product/" +(img ? img.replace("*", "S") : imagPardefaut.replace("*", "S")));
        },
        cartLoad: async function () {
          const cart = await THIS.rest("b2b.cart.get", {_id: this.idSelected});

          const substitute = await THIS.rest("b2b.SaveThe.getByOrder",{ _id: this.idSelected },"","");

          function enrichieSubstitute(rows, substitutes) {
            rows.forEach((u) => {
              let substitute = substitutes.find((uu) => u.reference == uu.substitutefor);
              if (substitute) {
                u.substitute = substitute;
                let refInOrder = rows.find((element) => element.reference == substitute.reference);
                // A voir avec JP
                u.substitute.refInOrder =  refInOrder && refInOrder.reference.length > 0;
              }
            });
          }
          enrichieSubstitute(cart.rows, substitute.rows)
          this.docOrder = cart;
        },

        createOrder() {
          Store.get("creatOrder")();
          /*  function (_id) {
								 THIS.hashLance("orderValidate", { _id });
						 } */
          objectConteneur.hide();
        },
        createBulk() {
          Store.get("creatBulk")(function (_id) {
            // alert("Create BULK!");
            THIS.hashLance("orderValidate", { _id });
          });
          objectConteneur.hide();
          // Store.get("creatOrder")();
          /*  function (_id) {
								 THIS.hashLance("orderValidate", { _id });
						 } */
          // 
        },

        continueShopping: async function () {
          /* 					console.log(this.idSelected)
										console.log(this.currentOrder) */
          if (this.docOrder._id != this.currentOrder._id) {
            await Store.get("setCurrentorder")(this.idSelected);
          }
          objectConteneur.hide();
        },

        async onShow() {
          this.listOrders = await Store.get("getOrderlist")();
          console.log( this.listOrders )
          const order = await Store.get("getCurrentOrder")();
          //
          if (order) {
            this.currentOrder = order;
            this.docOrder = order;
            this.idSelected = order._id;
          } else {
            this.currentOrder = { rows: [] };
            this.docOrder = { rows: [] };
            this.idSelected = "";
          }
        },
      },

      mounted() {
        const thisVue = this;
        //
        element.addEventListener("show.bs.offcanvas", async function () {
          /* console.log('show.bs.offcanvas') */
          thisVue.onShow();
        });
      },
    });
    app.mount(THIS.c$("._vueChargement")[0]);
  },
};

export default { js: jscart, html: htmlcart };
